import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { Formik, Form, Field } from 'formik';
import { useDispatch } from 'react-redux';

import i18n from 'i18n-js';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

import { BaseModal } from 'components/UI';
import { TextField } from 'components/FormFields';
import ImageTools from 'lib/imageTools';

import moment from 'moment';

const UploadImageSchema = Yup.object().shape({
  name: Yup.string().required('This field is required'),
});

const UploadImageModal = ({
  id,
  open,
  handleClick,
  file,
  onUploadImage,
  onReset,
  loadingSuccess,
  loadingUpload,
  data,
}) => {
  const dispatch = useDispatch();
  const formRef = useRef(null);
  const [thumbnail, setThumbnail] = useState();

  const generateThumbnail = () => {
    if (file) {
      const ImageTool = new ImageTools();
      const reader = new FileReader();
      reader.onloadend = () => {
        ImageTool.resize(file, { width: 1000, height: 1000 }, 1).then((_file) => {
          const image = URL.createObjectURL(_file);
          setThumbnail({ file: _file, image });
        });
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    if (loadingSuccess) {
      handleClick();
      onReset();
    }
  }, [loadingSuccess, handleClick, onReset, dispatch]);

  useEffect(() => {
    if (file) {
      generateThumbnail();
    }
  }, [file]) // eslint-disable-line

  const onSubmit = (values) => {
    const formData = new FormData();

    formData.append('name', values.name);
    formData.append('data', thumbnail?.file || file, file?.name || 'photo.png');

    if (data) {
      Object.keys(data).forEach((key) => {
        formData.append(key, data[key]);
      });
    }

    onUploadImage(formData);
  };

  const handleSubmit = () => {
    formRef.current.submitForm();
  };

  return (
    <BaseModal
      size="sm"
      open={open}
      hasEnterButton
      hasCancelButton
      onEnter={handleSubmit}
      onCancel={handleClick}
      handleClick={handleClick}
      enableCloseButton={false}
      loading={loadingUpload}
      title={i18n.t('common.upload_picture')}
      enterButtonLabel={i18n.t('common.upload_image')}
    >
      <Grid container direction="column" alignItems="flex-start">
        <Box width="100%">
          <Formik
            innerRef={formRef}
            initialValues={{
              name: moment().format('x'),
            }}
            validationSchema={UploadImageSchema}
            onSubmit={onSubmit}
          >
            {({ handleSubmit }) => (
              <Form noValidate onSubmit={handleSubmit}>
                <Box mt={3} textAlign="center">
                  {thumbnail && (
                    <img
                      style={{
                        maxWidth: 250,
                        maxHeight: 250,
                      }}
                      src={thumbnail?.image || thumbnail}
                      alt="thumbnail"
                    />
                  )}
                </Box>
                <Box mt={1}>
                  <Field name="name" label="Picture name" component={TextField} />
                </Box>
              </Form>
            )}
          </Formik>
        </Box>
      </Grid>
    </BaseModal>
  );
};

UploadImageModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
  data: PropTypes.object,
};

UploadImageModal.defaultProps = {
  open: false,
  handleClick: () => {},
};

export default UploadImageModal;
